import { Reveal, Splash } from "./decor";
import { MapPin, Flag } from "lucide-react";

export const AboutLuca = ({ t }) => {
  return (
    <section id="about" className="relative overflow-hidden bg-black py-24 text-white lg:py-32">
      <Splash className="left-[-120px] top-10 h-[380px] w-[380px]" color="#0066FF" />
      <Splash className="right-[-120px] bottom-0 h-[420px] w-[420px]" color="#FF6B00" delay={0.2} />

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-[0.85fr_1.15fr] lg:px-10">
        <Reveal>
          <div className="relative mx-auto max-w-sm">
            <div className="absolute -left-5 -top-5 z-10 flex items-center gap-1.5 rounded-full bg-[#FF6B00] px-4 py-2 text-sm font-bold text-white shadow-lg">
              <MapPin className="h-4 w-4" /> 3 countries
            </div>
            <div className="overflow-hidden rounded-[2.5rem] border border-white/10">
              <img
                src="/luca.jpg"
                alt="Luca, language educator"
                className="h-[460px] w-full object-cover object-top"
                data-testid="about-image"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 z-10 flex items-center gap-1.5 rounded-full bg-[#00C853] px-4 py-2 text-sm font-bold text-black shadow-lg">
              <Flag className="h-4 w-4" /> since 1997
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.35em] text-[#FFD600]">
            {t.about.eyebrow}
          </p>
          <h2 className="font-display text-4xl font-black leading-tight tracking-tight sm:text-5xl">
            {t.about.title}
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70">{t.about.body}</p>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-white/15 pt-8">
            {t.about.stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <p className="font-display text-4xl font-black text-white lg:text-5xl">{s.value}</p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-white/50">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
